import globals from '../../../components/common/globals';

export default {
  name: 'vx-mystery-footer',
  data() {
    return {
      globals,
    };
  },
};



// WEBPACK FOOTER //
// ./src/marketingpages/components/vx-mystery-footer/vx-mystery-footer.js